export const GET_APPEALS_STATISTICS = 'GET_APPEALS_STATISTICS'
export const GET_CERTORDERS_STATISTICS = 'GET_CERTORDERS_STATISTICS'
